import { Children, isValidElement, type ReactElement } from "react";
import type { WidgetComponent } from "@viz/presentation";

const Split: WidgetComponent = ({ props, children }) => {
  const direction = (props.direction as "row" | "col" | undefined) ?? "row";
  const ratio = (props.ratio as number | undefined) ?? 0.5;
  const arr = Children.toArray(children).filter(isValidElement) as ReactElement[];
  const [a, b] = arr;
  const a1 = `${ratio * 100}%`, b1 = `${(1 - ratio) * 100}%`;
  return (
    <div className={`flex h-full w-full ${direction === "row" ? "flex-row" : "flex-col"}`}>
      <div style={direction === "row" ? { width: a1 } : { height: a1 }} className="overflow-auto">{a}</div>
      <div className="bg-slate-800/60" style={direction === "row" ? { width: 1 } : { height: 1 }} />
      <div style={direction === "row" ? { width: b1 } : { height: b1 }} className="overflow-auto">{b}</div>
    </div>
  );
};

export default Split;
